<template>
  <a-drawer :visible="showFlag" width="400" class="content" placement="right" :closable="false" @close="hide">
    <a-spin :delay="300" :spinning="spinning">

      <div v-for="(item, index) in dataSource" :key="index" :id="item.id" style="position: relative;">
        <!-- 删除按钮 -->
        <a>
          <a-popconfirm title="确认要删除?" @confirm="del(item)">
            <a-icon style="position: absolute;top:-2px;right:-2px;font-size: 21px;" type="close-circle"></a-icon>
          </a-popconfirm>
        </a>

        <a-descriptions :column="1" bordered style="margin-top: 10px;">

          <a-descriptions-item label="序号">
            <span style="position: relative;">{{ item.id }}</span>
            <!-- <a-icon style="color: black;position: relative;top: -15px;left: 120px;font-size: 21px;" @click="del(item)"
              type="close-circle"></a-icon> -->
          </a-descriptions-item>

          <a-descriptions-item label="推广位">
            {{ item.pid }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            <span ref="remarkSpan">
              {{ item.remark }}
              <a-icon type="edit" @click="editRemarkFn(item, index)"></a-icon>
            </span>
            <key-input ref="remarKeyInput" :iptVal="item.remark"
              @blurRemark="blurRemark(arguments, item, index)"></key-input>
          </a-descriptions-item>

          <a-descriptions-item class="descStyle" label="同步给客户端id">
            <span ref="robitSpan">
              {{ decorate(item.robot_map) }}
              <a-icon type="edit" @click="editRobitFn(item, index)"></a-icon>
            </span>
            <key-input ref="robitKeyInput" :iptVal="decorate(item.robot_map)" :type="1" @blurRemark="blurRobit(arguments, item, index)"></key-input>
          </a-descriptions-item>

          <a-descriptions-item label="更新时间">
            {{ item.update_time }}
          </a-descriptions-item>

        </a-descriptions>
      </div>


      <a-form>
        <a-form-item label="新增推广位" v-for="(item, index) in inputList" :key="index">

          <a-input type="text" v-model="pid" placeholder="pid" allow-clear />
          <div v-if="!pidErrpr" class="tip">仅支持一个pid,请不要填写多个！！！</div>
          <div v-if="pidErrpr" class="tipErrpr">pid不能为空！！！</div>

          <a-input type="text" v-model="mark" placeholder="备注" allow-clear />

          <a-input type="text" v-model="robits" placeholder="机器人id" allow-clear />
          <div v-if="!robitsErrpr" class="tip">多个机器人id,请使用英文逗号","隔开,不要换行！！！</div>
          <div v-if="robitsErrpr" class="tipErrpr">机器人id不能为空！！！</div>

        </a-form-item>
      </a-form>


      <div class="footerBtn">
        <a-button type="primary" v-if="changeFlag == 'add'" @click="addTgw" style="margin-right: 15px;">新增</a-button>
        <a-button v-if="changeFlag == 'save'" @click="cancelTgw" style="margin-right: 15px;">取消</a-button>
        <a-button type="primary" v-if="changeFlag == 'save'" :disabled="saveBtnOk" @click="save">保存</a-button>
      </div>

    </a-spin>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import KeyInput from './KeyInput'

import CompanyApi from '@/api/company'

export default {
  data() {
    return {
      showFlag: false,
      spinning: false,
      rowData: {},
      dataSource: [], // 接口res
      inputList: [], // 默认有一个input框显示

      pid: '', // 新增时的pid
      mark: '', // 新增时的备注
      robits: '', // 新增时的机器人id

      pidErrpr: false, // pid是否为空
      robitsErrpr: false, // robits是否为空

      changeFlag: 'add',

      saveBtnOk: true, // 保存按钮可点击
    }
  },

  components: {
    KeyInput,
  },

  watch: {
    pid: {
      immediate: true,
      handler(newVal, oldval) {
        if (newVal == '') {
          this.pidErrpr = true
          this.saveBtnOk = true
        } else {
          this.pidErrpr = false
          if (this.robitsErrpr == false) {
            this.saveBtnOk = false
          }
        }
      }
    },
    robits: {
      immediate: true,
      handler(newVal, oldval) {
        if (newVal == '') {
          this.robitsErrpr = true
          this.saveBtnOk = true
        } else {
          this.robitsErrpr = false
          if (this.pidErrpr == false) {
            this.saveBtnOk = false
          }
        }
      }
    },

  },

  methods: {
    show(rowData) {
      this.rowData = rowData
      // console.log('==', rowData)
      this.getList({
        page: 1,
        size: 1000,
        authority_id: this.rowData.authority_id,
      })
    },

    hide() {
      this.showFlag = false
      this.cancelTgw()
    },

    // 格式化时间
    uptTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },

    // 格式化推广位的展示
    decorate(value) {
      let temp = JSON.parse(value)
      // console.log('temp=', temp)
      let result = temp.join(',')
      return result
    },

    // 获取淘宝联盟 - 自定义推广位列表
    async getList(data) {
      this.dataSource = []
      let result = await CompanyApi.getDyTgwList(data)
      this.dataSource = result.data.list
      this.showFlag = true
    },

    // 添加推广位
    addTgw() {
      this.inputList = [""]
      this.changeFlag = 'save'
    },

    // 编辑Robit
    editRobitFn(item, index) {
      // console.log('--', this.$refs.robitSpan)
      // console.log('==', this.$refs.robitKeyInput)
      this.$refs.robitKeyInput[index].$el.classList.remove('none')
      this.$refs.robitSpan[index].classList.add('none')
    },

    blurRobit(args, item, index) {
      this.spinning = true
      this.editRobitFlag = false
      let data = {
        pid: item.pid,
        id: item.id,
        robot_map: args[0],
        remark: item.remark
      }
      CompanyApi.editDyTgw(data)
        .then(res => {
          this.getList({
            authority_id: this.rowData.authority_id,
          })
            .finally(() => {
              this.spinning = false
              this.$nextTick(() => {
                this.$refs.robitKeyInput[index].$el.classList.add('none')
                this.$refs.robitSpan[index].classList.remove('none')
              })
            })
        })
    },

    // 编辑备注
    editRemarkFn(item, index) {
      // console.log('--', this.$refs.remarkSpan)
      // console.log('==', this.$refs.remarKeyInput)
      this.$refs.remarKeyInput[index].$el.classList.remove('none')
      this.$refs.remarkSpan[index].classList.add('none')
    },

    blurRemark(args, item, index) {
      this.spinning = true
      this.editRemarkFlag = false
      let data = {
        pid: item.pid,
        id: item.id,
        robot_map: this.decorate(item.robot_map),
        remark: args[0]
      }
      CompanyApi.editDyTgw(data)
        .then(res => {
          // console.log('编辑推广位=', res)
          this.getList({
            authority_id: this.rowData.authority_id,
          })
            .finally(() => {
              this.spinning = false
              this.$nextTick(() => {
                this.$refs.remarKeyInput[index].$el.classList.add('none')
                this.$refs.remarkSpan[index].classList.remove('none')
              })
            })
        })
    },

    // 保存
    save() {
      this.spinning = true
      let data = {
        authority_id: this.rowData.authority_id,
        pid: this.pid,
        remark: this.mark,
        robot_map: this.robits,
      }

      // console.log('保存=', data)
      CompanyApi.saveDyTgw(data)
        .then(res => {
          // console.log('增加推广位=', res)
          this.inputList = []
          this.$message.success(res.msg)
          this.changeFlag = 'add'
        })
        .finally(() => {
          this.getList({
            authority_id: this.rowData.authority_id,
          })
            .finally(() => {
              this.spinning = false
            })
        })
    },

    // 取消添加推广位
    cancelTgw() {
      this.inputList = []
      this.changeFlag = 'add'
    },

    // 删除
    del(item) {
      this.spinning = true
      CompanyApi.delDyTgw({
        id: item.id,
        pid: item.pid
      })
        .then(res => {
          this.$message.success(res.msg)
        })
        .finally(() => {
          this.getList({
            authority_id: this.rowData.authority_id,
          })
            .finally(() => {
              this.spinning = false
            })
        })
    },

  },

}
</script>

<style scoped>
.footerBtn {
  /* border: 1px solid red; */
  margin-top: 15px;
  text-align: right;
}

.tip {
  margin-top: -11px;
  color: #9d9d9d;
  margin-left: 8px;
}

.tipErrpr {
  margin-top: -11px;
  margin-left: 8px;
  color: red;
}

.block {
  display: block;
}

.none {
  display: none;
}
</style>